export default {
  username: 'Identifiant',
  password: 'Mot de passe',
  submit: 'Login',
  continue: 'Continuer sans se connecter',
  // error: 'Identifiant ou mot de passe incorrects',
  error:
    "C'è un errore oppure l'username o la password sono errati.<br/> La pagina verrà ricaricata tra qualche secondo oppure procedi manualmente.",
}
